import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import i18n from './config/i18n'

Vue.config.productionTip = false

// Setup plugins and get pinia instance
import { setupPlugins } from '@/config/plugins';
const { pinia } = setupPlugins();

// Setup axios configuration
import '@/config/axios';

// Setup router guards
import setupRouterGuards from '@/config/router-guards';
setupRouterGuards(router);

// Import component registrations
import '@/config/components/w-components.js';
import '@/config/components/nrc-components.js';

new Vue({
    vuetify,
    router,
    pinia,
    i18n,
    render: h => h(App)
}).$mount('#app')